<template>
  <div class="mainDiv">
    <div class="content">
      <mt-swipe :auto="4000" id="banner" style="height: 334px">
        <mt-swipe-item v-for="item in banners">
          <img class="banner" v-bind:src="item" alt="">
        </mt-swipe-item>
      </mt-swipe>
      <mt-swipe :auto="4000" style=" height: 30px;" :showIndicators="false">
        <mt-swipe-item v-for="news in newsList">
          <a class="mint-tab-item"  @click="$parent.$emit('input', news.id)">
            <router-link :to="'/news/news/'+news.id">
              <img class="newsIcon" src="../assets/cells/消息.png"/>{{news.title}}
            </router-link>
          </a>
        </mt-swipe-item>
      </mt-swipe>
       <div class="line"></div>
      <mt-cell :title="cell.title" v-for="cell in cells" is-link  :to="cell.url">
        <span>{{cell.value}}</span>
        <img class="val" slot="icon" v-bind:src="cell.icon" width="26" height="26">
      </mt-cell>

    </div>
  </div> 
</template>

<script>
    export default {
        name: "MainPage",
      data(){
        return {
          newsList:[],
          banners:
          [require("../assets/ad/banner1.png"),require("../assets/ad/banner2.png"),
            require("../assets/ad/banner3.png"),require("../assets/ad/banner4.png")],
          cells:[{title:"自我评测",value:"规划才会赢",icon:require("../assets/cells/自我测评.png"),url:"/test/test"},
            {title:"一键志愿",value:"让选择更简单",icon:require("../assets/cells/一键志愿.png"),url:"/student/overview"},
            {title:"志愿决策",value:"梦想看今朝",icon:require("../assets/cells/奖章.png"),url:"/collections"},
             {title:"高校之窗",value:"名校风采尽在于此",icon:require("../assets/cells/高校.png"),url:"/college/collegeList"},
            {title:"专业探索",value:"选专业就靠它",icon:require("../assets/cells/探索.png"),url:"/college/majorTypes"},
            {title:"招生章程",value:"招生章程",icon:require("../assets/cells/章程.png"),url:"/college/collegeList"},
            {title:"录取早知道",value:"录取早知道",icon:require("../assets/cells/knowEarly.png"),url:"/news/knowEarly"}]//vip功能
        }
      },
      created:function(){
          var vm = this;
          this.$http.get('/wx/latestNews').then(function (response) {
            console.log(response);
            vm.newsList = response.data.data;
          })
      },
      mounted:function(){
        var clientWidth = document.documentElement.clientWidth || window.innerWidth;
        document.querySelector("#banner").style.height = (clientWidth<620?(clientWidth*0.53):334) + 'px';
      }
    }
</script>
<style scoped>
  .mint-swipe img.banner{
    width: 100%;
  }
  .mint-swipe img.newsIcon{
    width:24px;
    height: 24px;
    vertical-align: top;
    margin:0 15px;
  }
 .mint-cell-wrapper img.val{
   margin-right: 14px;
 }
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue